import { formatMonth } from '../lib/dates'
import './MonthMark.css'

/**
 * La frontière entre deux mois, dans une liste d'opérations.
 *
 * Centrée entre deux traits plutôt qu'alignée à gauche : c'est une COUPURE
 * dans le temps, pas le titre de ce qui suit. Alignée à gauche, elle se lisait
 * comme un intitulé de plus au milieu des lignes, et on ne voyait plus où un
 * mois finissait.
 *
 * Le même composant sur l'accueil et sur les opérations : la même frontière
 * doit se reconnaître d'un écran à l'autre, et deux rendus qui se ressemblent
 * finissent toujours par diverger.
 */
export function MonthMark({ date, as = 'p' }: {
  /** N'importe quelle date du mois, au format AAAA-MM-JJ. */
  date: string
  /**
   * L'élément à produire. `li` quand la marque vit DANS la liste des lignes —
   * une `ul` ne doit contenir que des `li`, sous peine de rendre le balisage
   * invalide et la navigation par liste incohérente.
   */
  as?: 'p' | 'li'
}) {
  const Tag = as
  return (
    // `aria-hidden` : chaque ligne porte déjà sa date en toutes lettres, année
    // comprise. Annoncer le mois une seconde fois n'apprend rien et gonfle le
    // compte d'éléments d'une liste qui n'est censée contenir que des opérations.
    <Tag className="month-mark" aria-hidden="true">
      <span>{formatMonth(date)}</span>
    </Tag>
  )
}
